import { observable, action } from "mobx";
import agent from "../agent";

class LookupStore {
    @observable venueTypes = [];
    @observable instruments = [];
    @observable genres = [];
    genresLoaded = false;
    genreRequest = null;

    @action
    getGenreSuggestions(){
        if (this.genresLoaded) return Promise.resolve(this.genres);
        if (this.genreRequest) return this.genreRequest;
        this.genreRequest = agent.Genre.getAll().then(action(
            result => {
                // A missing response (including a failed auth retry) is not an empty catalog.
                if (!Array.isArray(result)) throw new Error("Unable to load genres");
                this.genres = result;
                this.genresLoaded = true;
                return this.genres;
            }
        )).finally(() => {
            this.genreRequest = null;
        });
        return this.genreRequest;
    }

    @action
    getVenueTypesSuggestion(){
        return agent.VenueType.getAll().then(action( result => {
            this.venueTypes = result;
            return this.venueTypes;
        }))
    }

    @action
    getInstruments() {
        if (this.instruments.length === 0) {
            return agent.Instrument.getAll().then(
                action(result => {
                    this.instruments = _.sortBy(result, o => o.name).map(instrument => ({
                        value: instrument.id,
                        label: instrument.name
                    }));
                })
            );
        } else {
            return Promise.resolve(this.instruments);
        }
    }

    @action
    getInstrumentsName(instruments){
        return instruments.split(",").map( instrument => {
            return this.instruments.filter(x => x.value === parseInt(instrument, 10))[0].label;
        }).join();
    }
}

export default new LookupStore();
